var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDragPanThin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "20px",
    viewBox: "0 -960 960 960",
    width: "20px",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M480-123.69 339.69-264l22.54-22.54L464-184.77V-464H184l101.77 102.54L264-339.69 123.69-480l141.08-141.08 22.54 22.54L184.77-496H464v-279.23L362.23-673.46 339.69-696 480-836.31 620.31-696l-22.54 22.54L496-775.23V-496h280L674.23-598.54 696-620.31 836.31-480 696-339.69l-22.54-22.54L775.23-464H496v280l102.54-101.77L620.31-264 480-123.69Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragPanThin);
export default __webpack_public_path__ + "static/media/drag_pan_thin.26fe602a300cb6b062e5d0f4faf6d905.svg";
export { ForwardRef as ReactComponent };